//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { PatchQuoteStatusRequest } from '@apis/campaign-requests/sampling/quote/samplingQuoteApiModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const QUOTE_DEFAULT_ENDPOINT = '/api/v1/clients/quote';

const quoteFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> =>
  serializedGatewayFetch(
    'sampling_gateway',
    `${QUOTE_DEFAULT_ENDPOINT}${endpoint}`,
    init,
  );

/**
 * Updates the status of a quote.
 *
 * PATCH /api/v1/clients/quote/:quoteId
 */
export const patchQuoteStatus = async (
  req: PatchQuoteStatusRequest,
  init?: RequestInit,
): Promise<void> => {
  await quoteFetch(`/${req.quoteId}`, {
    ...init,
    method: 'PATCH',
    body: JSON.stringify(req.payload),
  });
};
